

















import { Config } from 'truemarket-modules/src/environment'
import GetValuerProfileModel from 'truemarket-modules/src/models/api/valuations/GetValuerProfileModel'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ValuerProfileByline extends Vue {
  @Prop()
  private readonly valuer!: GetValuerProfileModel;

  private readonly apiBase = Config.API.Base
}
